import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import HomePage from "@/pages/HomePage";
import ExperiencesPage from "@/pages/ExperiencesPage";
import AboutPage from "@/pages/AboutPage";
import CitiesPage from "@/pages/CitiesPage";
import ContactPage from "@/pages/ContactPage";
import AdminDashboard from "@/pages/AdminDashboard";
import MembersPortal from "@/pages/MembersPortal";
import BookConsultation from "@/pages/BookConsultation";

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <SettingsProvider>
          <div className="App min-h-screen bg-obsidian">
            <BrowserRouter>
              <div className="noise-overlay" />
              <Navigation />
              <main>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/experiences" element={<ExperiencesPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/cities" element={<CitiesPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/book" element={<BookConsultation />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/members" element={<MembersPortal />} />
                </Routes>
              </main>
              <Footer />
              <WhatsAppButton />
              <Toaster 
                position="bottom-right"
                toastOptions={{
                  style: {
                    background: '#0A0A0A',
                    border: '1px solid #27272A',
                    color: '#F5F5F0'
                  }
                }}
              />
            </BrowserRouter>
          </div>
        </SettingsProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
